import { IconButton, type IconButtonProps } from '@chakra-ui/react'
import { ColorScheme, ButtonVariant, SizeType } from '@/types'
import React from 'react'

interface Props extends Omit<IconButtonProps, 'aria-label'> {
  colorScheme?: ColorScheme,
  variant?: ButtonVariant,
  size?: SizeType,
  "aria-label"?: string,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <IconButton ref={ref} px={0} aria-label={''} { ...props } />
  )
})


export {
  Component as IconButton,
  type Props as IconButtonProps,
}